import React from "react";
import { Tabs, Tab, Card, CardBody } from "@nextui-org/react";

function Roadmap() {
    return (
        <div className="Roadmap" id="roadmap">
            <div style={{ color: 'white' }}>
                <h1 style={{ fontSize: '80px', fontWeight: 800, paddingLeft: '200px', paddingRight: '200px' }}>NFD - game changing crypto platform</h1>
                <br></br>
                <div classname='blink'>
                    <h4 style={{ fontSize: '50px' }}>----</h4>

                </div>

            </div>

            <div style={{ color: 'white', display: 'flex', justifyContent: 'center', width: '100%' }}>
                <div>
                    <Tabs aria-label="Options">
                        <Tab style={{ fontSize: '16px', padding: '20px' }} key="photos" title="Stage-1">
                            <Card style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px' }}>
                                <CardBody style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                    backgroundColor: '#f7f7f7'
                                }}>
                                    
                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                            Development
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                            Activities and Aggregator
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                            Alpha test
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                            Alpha search tool
                                        </li>

                                        <li style={{ fontWeight: 'bold', color: '#333' }}>
                                            Beta test
                                        </li>
                                    
                                </CardBody>
                            </Card>
                        </Tab>

                        <Tab style={{ fontSize: '16px', padding: '20px' }} key="satge-2" title="Stage-2">
                            <Card style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px' }}>
                                <CardBody style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                    backgroundColor: '#f7f7f7'
                                }}>
                                   
                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>

                                            ROI scanner
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Aggregator “Summary”
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Twitter Scanner tool
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                            Alpha search tool
                                        </li>

                                        <li style={{ fontWeight: 'bold', color: '#333' }}>
                                        Whale’s analysis
                                        </li>

                                        <li style={{ fontWeight: 'bold', color: '#333' }}>
                                        Blocks in Aggregator
                                        </li>
                                    
                                </CardBody>
                            </Card>
                        </Tab>

                        <Tab style={{ fontSize: '16px', padding: '20px' }} key="satge-3" title="Stage-3">
                            <Card style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px' }}>
                                <CardBody style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                    backgroundColor: '#f7f7f7'
                                }}>
                                   
                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        New sections in “Activities”

                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Launching NFD DAO
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Expanding the calendar
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Token vesting tool
                                        </li>

                                        <li style={{ fontWeight: 'bold', color: '#333' }}>
                                        NFD labs incubator
                                        </li>

                                    
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab style={{ fontSize: '16px', padding: '20px' }} key="satge-4" title="Stage-4">
                            <Card style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px' }}>
                                <CardBody style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                    backgroundColor: '#f7f7f7'
                                }}>
                                    
                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Crypto arbitrage scanner

                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Alpha search AI developing based on data collected
                                        </li>

                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        Adding any services based on NFD DAO votes
                                        </li>

                                        

                                    
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab style={{ fontSize: '16px', padding: '20px' }} key="satge-5" title="Stage-5">
                            <Card style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px' }}>
                                <CardBody style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                    backgroundColor: '#f7f7f7'
                                }}>
                                    
                                        <li style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                        The launch of Project “X” by NFD labs, which will change the culture of crypto investment

                                        </li>

                                        

                                    
                                </CardBody>
                            </Card>
                        </Tab>
                        
                        
                    </Tabs>
                </div>

            </div>
        </div>
    )
}

export default Roadmap